import React from 'react'
import { useSelector } from 'react-redux'
import TopSearchItem from '../../genericComponents/topSearch/TopSearchItem'
import { selectTopSearchLinks } from '../../../store/seo/seo.selectors'
import s from './TopSearchLinks.less'
import { selectShouldDisplayTopSearchTitle } from './seo-footer.selectors'
import T from '../../i18n/T'

const ID = 'TopSearchLinks'

export const TopSearchLinks = () => {
  const topSearchLinks = useSelector(selectTopSearchLinks)
  const shouldDisplayTitle = useSelector(selectShouldDisplayTopSearchTitle)

  if (__BROWSER__) {
    const element = document.getElementById(ID)
    return element ? (
      <div id={ID} dangerouslySetInnerHTML={{ __html: element.innerHTML }} className={s.root}></div>
    ) : null
  }

  if (!topSearchLinks || topSearchLinks.length === 0) return <></>

  return (
    <div id={ID}>
      {shouldDisplayTitle === true && (
        <h2 className={s.title}>
          <T id={'footer.top-search.title'} />
        </h2>
      )}
      {topSearchLinks.map((links, idx) => (
        <TopSearchItem {...links} key={idx} />
      ))}
    </div>
  )
}

export default TopSearchLinks
